import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const agencySchema: CollectionCreateSchema = {
  name: CollectionName.Agency,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      infix: true,
    },
    {
      name: "identifier",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "agency_type",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "display_name",
      type: "string",
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "address",
      type: "object",
      optional: true,
      infix: true,
      fields: [
        {
          name: "physical_address",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_city",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_state",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_country_code",
          type: "string",
          infix: true,
          optional: true,
        },
      ],
    },
    {
      name: "source_system_id",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "accessible_by",
      type: "string[]",
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Private,
}
